import {Logger} from "./flair/Logger.es6";
Logger.setLogLevel(Logger.LEVEL_WARNING);
